import _get from 'lodash/get';
import {
  FilterGroupingEnum,
  FormTemplateFilterInputObject,
} from 'graphql-common';
import { Values } from '@lib/interfaces/form';
import { FieldNames } from '../enums';

interface OptionItem {
  value: string;
  label: string;
  [key: string]: unknown;
}

export function createAdditionalFilters(
  filterValues: Values,
): FormTemplateFilterInputObject[] {
  const filters: FormTemplateFilterInputObject[] = [];

  const formCategories = _get(
    filterValues,
    FieldNames.FormCategories,
    [],
  ) as OptionItem[];
  if (formCategories && formCategories.length > 0) {
    const categoryIds = formCategories.map((category) => category.value);
    filters.push({
      categoryId: {
        grouping: FilterGroupingEnum.And,
        predicate: { in: categoryIds },
        filterGroup: 'additionalFilters',
      },
    });
  }

  return filters;
}
